import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import ReactTable from "react-table-6";
import Loader from 'react-loader-spinner';
import "react-table-6/react-table.css";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";

class BotStoreTickets extends Component {
    constructor() {
        super(...arguments);
        this.dialogClose = () => {
            this.setState({ showTicketStatusPopup: false, hideLogoutConfirmation: false, showTicketStatusOpenPopup: false, });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };
        this.Okbutton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.dialogInstance.hide();
                this.setState({ createNewProjectPage: false });
                this.setState({ hideCommentAddedDialog: false });
            }
        }],
            this.createProjectbutton = [{
                buttonModel: {
                    content: 'OK',
                    cssClass: 'e-flat',
                    isPrimary: true,
                },
                'click': () => {
                    this.state.createNewProjectPage = false;
                    this.props.history.push('/project-plan-settings');
                }
            }],
            this.ticketStatusButton = [{
                buttonModel: {
                    content: 'Yes',
                    cssClass: 'e-flat',
                    isPrimary: true,

                },
                'click': props => {
                    this.updateTicketStatusApi(this.state.editedId, this.state.ticketDescription,
                        this.state.ticketPriority, this.state.ticketStatus, this.state.ticketType,
                        this.state.ticketTitle)
                }
            }
                , {
                buttonModel: {
                    content: 'No',
                    cssClass: 'e-flat',
                    isPrimary: true,
                },
                'click': () => {
                    this.setState({ showTicketStatusOpenPopup: false, showTicketStatusPopup: false });
                }
            }];


        this.state = {
            showNoTicket: false,
            showRaiseTicket: false,
            showPostCommentsTextArea: false,
            hideLoader: false,
            projectDetails: {},
            ticketStatusDropDown:false,
            data: [{
                domain: '',
                id: '',
                language: [],
                lastBuildTime: '',
                lastModifiedBy: '',
                lastModifiedDate: '',
                name: '',
                projectDescription: ''

            }],
            ticketData: [{
                title: '',
                description: '',
                ticketStatus: '',
                ticketPriority: '',
                ticketType: '',
                id: ''

            }],
            ticketInfo: [{
                ticketId: '',
                commentedByUserId: '',
                commentedByUserName: '',
                commentedByUserEmail: '',
                comment: '',
                commentType: '',
                commentTime: '',

            }],
            editedId: '-1',
            ticketTitle: '',
            ticketDescription: '',
            ticketFileName: '',
            ticketFileType: '',
            ticketImageFile: '',
            ticketPriority: '',
            ticketStatus: '',
            ticketType: '',
            lastModifiedDate: '',
            showTicketStatusPopup: false,
            showTicketStatusOpenPopup: false
        }
        this.createdDate = '';
        this.domainVar = [];
        this.statusVar = [];
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    }

    componentDidMount = () => {
        setTimeout(() => {
            this.fetchTicketDataApi();
        }, 300);

        var thisComponent = this;
        document.addEventListener("projectChanged", function (event) {
            thisComponent.state.hideLoader = false;
            thisComponent.setState(thisComponent.state);
            thisComponent.projectId = event.projectId;
            thisComponent.fetchTicketDataApi(event.projectId);
        });
    }

    notifySuccessMsg(Projectkey) {
        window.scrollTo(0, 0)
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;{Projectkey}</b>, {
            position: "top-center"
        });
    }

    notifyEmptyFields() {
        toast.dismiss();
        toast(<b>Please fill all fields</b>, {
            position: "top-center",


        });
    }
    notifyEmptyCommentField() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Please enter your comment before submitting</b>, {
            position: "top-center",


        });
    }

    notifyFailToCreate(falseRes) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{falseRes}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    nullValuePopup() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred. Please try again</b>, {
            position: "top-center",
            color: "red"

        });
    }



    updateTicketStatusApi = (ticketid, description,
        ticketPriority, ticketStatus, ticketType, title) => {
        var ticketStatusController = this;
        var statusChanged = (ticketStatus === "OPEN") ? "CLOSED" : "OPEN";
        var updatedData = {
            "userId": JSON.parse(localStorage.getItem("user_details"))["userId"],
            "projectId": ticketStatusController.state.projectDetails.id,
            "description": description,
            "id": ticketid,
            "ticketPriority": ticketPriority,
            "ticketStatus": statusChanged,
            "ticketType": ticketType,
            "title": title,
        }

        $.ajax({
            url: "/api/generate-ticket",
            async: false,
            method: 'PATCH',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(updatedData),
            processData: false,
            contentType: "application/json; charset=UTF-8",
            success: function (res) {
                if (res.success === true) {

                    ticketStatusController.setState({ showTicketStatusOpenPopup: false, showTicketStatusPopup: false });
                    ticketStatusController.notifySuccessMsg("Ticket status Updated Successfully");
                    ticketStatusController.fetchTicketDataApi();

                } else if (res.success === false && res.result.includes("null")) {
                    ticketStatusController.nullValuePopup();

                } else {
                    ticketStatusController.notifyFailToCreate(res.result);


                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        })

    }

    fetchCommentsApi(ticketCommentId, projectId) {
        var ticketController = this;

        $.ajax({
            url: "/api/ticket-comments",
            async: false,
            method: 'GET',
            data: {
                "userId": JSON.parse(localStorage.getItem("user_details"))["userId"],
                "projectId": projectId,
                ticketId: ticketCommentId
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    ticketController.fetchProjectDetailsAPi(res.result[0].projectId);
                    for (var i = 0; i < res.result.length; i++) {
                        if (res.result[i]['commentTime'] == 0) {
                            res.result[i]['commentTime'] = ticketController.createdDate;
                        } else if (res.result[i]['commentTime'] != '0' && res.result[i]['commentTime'] != null) {
                            var date = new Date(res.result[i]['commentTime']);
                            res.result[i]['commentTime'] = date.toLocaleString();
                        }
                    }
                    ticketController.state.showPostCommentsTextArea = false;
                    ticketController.setState({ ticketInfo: res.result });

                } else if (res.success === false && res.result.includes("null")) {
                    ticketController.nullValuePopup();

                } else {
                    ticketController.notifyFailToCreate(res.result);


                }


            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }




    fetchTicketDataApi(projectId) {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var ticketController = this;
        $.ajax({
            url: "/api/client-bot-tickets",
            async: false,
            method: 'GET',
            data: {
                "templateProjectId": projectId,
                "showClosed": ticketController.state.ticketStatusDropDown
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                ticketController.state.hideLoader = true;
                ticketController.setState(ticketController.state);
                if (res.success === true && res.result.length !== 0) {
                    var fullPath = res.result[0].ticketFileName;
                    var filename = fullPath.replace(/^.*[\\\/]/, '');
                    var date = new Date(res.result[res.result.length - 1].lastModifiedDate);
                    var date1 = new Date(res.result[0].createdDate);
                    ticketController.state.showNoTicket = false;
                    ticketController.state.ticketData = res.result;
                    ticketController.state.editedId = res.result[0].id;
                    ticketController.state.ticketTitle = res.result[0].title;
                    ticketController.state.ticketDescription = res.result[0].description;
                    ticketController.state.ticketStatus = res.result[0].ticketStatus;
                    ticketController.state.ticketType = res.result[0].ticketType;
                    ticketController.state.ticketPriority = res.result[0].ticketPriority;
                    ticketController.state.lastModifiedDate = date.toLocaleString();
                    ticketController.state.ticketFileName = filename;
                    ticketController.setState(ticketController.state);
                    ticketController.createdDate = date1.toLocaleString();
                    ticketController.fetchCommentsApi(res.result[0].id, res.result[0].projectId);

                } else if (res.success === true && res.result.length == 0) {
                    ticketController.setState({
                        showNoTicket: true,
                        ticketData: [],
                        ticketInfo: [],
                        editedId: '-1', ticketTitle: '',
                        ticketDescription: '',
                        ticketStatus: '',
                        ticketType: '',
                        ticketPriority: '',
                        lastModifiedDate: '',
                        ticketFileName: ''
                    });
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    openTicket(props, e) {
        var fullPath = props.original.ticketFileName;
        var filename = fullPath.replace(/^.*[\\\/]/, '');
        var date = new Date(props.original.lastModifiedDate);
        this.setState({
            editedId: props.original.id, ticketTitle: props.original.title,
            ticketDescription: props.original.description,
            ticketStatus: props.original.ticketStatus,
            ticketType: props.original.ticketType,
            ticketPriority: props.original.ticketPriority,
            lastModifiedDate: date.toLocaleString(),
            ticketFileName: filename,
            projectId: props.original.projectId
        });
        this.fetchCommentsApi(props.original.id, props.original.projectId);

    }

    showStatusClosePopup = () => {
        if (this.state.ticketStatus == "OPEN") {
            this.state.showTicketStatusPopup = true;
        } else {
            this.state.showTicketStatusOpenPopup = true;
        }
        this.setState(this.state);
    }

    statushandlechange = (event) => {
        event.preventDefault();
       // this.state.ticketStatusDropDown = event.target.value;
        this.setState({
            ticketStatusDropDown:event.target.value
        });
        this.setState(this.state);
        this.fetchTicketDataApi();
    }

    saveTicketCommentsApi = () => {
        var ticketController = this;
        if (document.getElementById("comment").value.trim() == "") {
            ticketController.notifyEmptyCommentField();
        } else {
            var ticketCommentData = {
                commentedByUserId: JSON.parse(localStorage.getItem("user_details"))["userId"],
                comment: document.getElementById("comment").value.trim(),
                ticketId: this.state.editedId,
                projectId: ticketController.state.projectDetails.id,

            };

            $.ajax({
                url: "/api/ticket-comments",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(ticketCommentData),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        ticketController.notifySuccessMsg("Comment added successfully");
                        ticketController.fetchCommentsApi(ticketCommentData.ticketId, ticketController.state.projectDetails.id);

                        document.getElementById("comment").value = "";

                    } else if (res.success === false && res.result.includes("null")) {
                        ticketController.nullValuePopup();

                    } else {
                        ticketController.notifyFailToCreate(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            });
        }
    }

    showPostCommentsTextAreaFunc = () => {
        if (this.state.showPostCommentsTextArea == false) {
            this.setState({ showPostCommentsTextArea: true });
        }
        else {
            this.setState({ showPostCommentsTextArea: false });
        }
    }

    handleChangeComments = (e) => {
        document.getElementById("comment").value = e.target.value;
    }

    routeToClientBot = () => {
        var ticketComponent = this;
        document.getElementById("projectDropdown").value = ticketComponent.state.projectDetails.id;
        localStorage.setItem("currentProjectId", ticketComponent.state.projectDetails.id);
        localStorage.setItem("currentProjectName", ticketComponent.state.projectDetails.name);
        document.dispatchEvent(new CustomEvent("projectChanged", {
            projectId: ticketComponent.state.projectDetails.id
        }));

        window.location.href = "/platform/projectmgmt";
    }

    fetchProjectDetailsAPi = (projectId) => {
        var ticketComponent = this;
        $.ajax({
            url: "/api/project-details",
            async: false,
            method: 'GET',
            data: {
                "projectId": projectId
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    ticketComponent.state.projectDetails = res.result;
                    ticketComponent.setState(ticketComponent.state);
                }
            }
        })
    }

    render() {

        return (

            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!this.state.hideLoader}
                    height={400}
                    width={50}
                    style={{ textAlign: 'center' }} />
                <link rel="stylesheet" href="assets/css/reactToastify.css" />

                < ToastContainer className="Toast-at-center" />
                <link rel="stylesheet" href="/assets/css/style.css" />
                {/* for toaster */}
                <link rel="stylesheet" href="/assets/css/reactToastify.css" />
                <link rel="stylesheet" href="assets/css/material.css" />
                <link rel="stylesheet" href="assets/css/buttonForm.css" />
                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />

                <div className="row" style={{ marginLeft: '15px', display: this.state.hideLoader ? 'block' : 'none' }}>
                    <h6 class="nav-item"
                        style={{
                            color: "rgb(40, 42, 101)",
                            marginTop: "24px 0px 0px 2px"
                        }}>Your Tickets
                    </h6>
                </div>
                <div className="row">
                    <div className='col-sm-12' style={{
                        background: "#F9F9FB"
                    }}>
                        <div className="col-sm-12" >
                            <div className="modal-body">
                                <form className="form-control" style={{ height: '700px', display: this.state.showRaiseTicket ? 'none' : 'block' }} >
                                    <div className="row" style={{ margin: '30px' }}>
                                        <div className="col-sm-3">
                                            <div Align="left">
                                                <select id="ticket-status-drop-down" className="form-control select2 " onChange={this.statushandlechange} style={{ width: '50%', marginTop: "12px" }}>
                                                    <option value="false">OPEN</option>
                                                    <option value="true">CLOSED</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <h4 style={{ textAlign: 'center' }}>Ticket History</h4>
                                        </div>
                                    </div>
                                    <hr />
                                    <form>

                                        <div className="content">
                                            <div className="row">
                                                <div className="col-lg-3 ">
                                                    <div className="card">
                                                        <ReactTable id='reactTable'
                                                            data={this.state.ticketData}
                                                            noDataText="No Tickets Found"
                                                            columns={[
                                                                {
                                                                    Header: <b>Tickets</b>,
                                                                    accessor: 'title',
                                                                    overflow: "visible",
                                                                    sortable: false,
                                                                    Cell: props => (
                                                                        <div Align="left" className="cursor-change"
                                                                            onClick={(e) => {
                                                                                this.openTicket(props, e);
                                                                            }}
                                                                            contentEditable={false}>
                                                                            <div class="listContent userIdBox">
                                                                                <div style={{ marginTop: "15px" }}
                                                                                    contentEditable={false}
                                                                                    suppressContentEditableWarning
                                                                                    type="text" id={"ticketTictle" + props.index}>
                                                                                    <b>{props.original.title === '' ? 'No Tickets Found' : props.original.title}</b></div></div>
                                                                            <div class="listContent userIdBox">
                                                                                <div
                                                                                    contentEditable={false}
                                                                                    suppressContentEditableWarning
                                                                                    type="text" id={"ticketTictle" + props.index}
                                                                                >{props.original.ticketType}</div>
                                                                                <div style={{ Align: "right", color: (props.original.ticketPriority === "CRITICAL") ? "red" : "orange" }}
                                                                                    contentEditable={false}
                                                                                    suppressContentEditableWarning
                                                                                    type="text" id={"ticketTictle" + props.index}
                                                                                >{props.original.ticketPriority}</div>
                                                                                <div style={{ Align: "right" }}
                                                                                    contentEditable={false}
                                                                                    suppressContentEditableWarning
                                                                                    type="text" id={"ticketTictle" + props.index}>
                                                                                    <button type='button' style={{ display: this.state.showNoTicket ? 'none' : 'block', fontWeight: 'bold', height: '27px', fontSize: '10px', width: '100px', marginLeft: '10%' }}
                                                                                        className='btn action-button'
                                                                                        onClick={this.showStatusClosePopup}>{this.state.ticketStatus == "OPEN" ? "CLOSE TICKET" : "OPEN TICKET"}</button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }
                                                            ]}
                                                            showPagination={false}
                                                            className="-highlight"
                                                            style={{ height: "480px" }}
                                                            pageSize={this.state.ticketData.length}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-sm-9' style={{ display: this.state.showNoTicket ? 'block' : 'none', height: '500px' }}>
                                                    <form className="form-control" style={{ height: '466px' }} Align='center'>
                                                        <div style={{ padding: '150px 70px 70px 70px' }}>
                                                            <img src="./assets/images/warn.svg" height="50px" width="50px" />
                                                            <br /><br />
                                                            <label style={{ fontSize: '20px' }}>
                                                                Not Attending Any Tickets Now
                                                            </label><br />
                                                        </div>
                                                    </form>
                                                </div>
                                                <div className="col-lg-9" style={{
                                                    backgroundColor: "#ffffff",
                                                    display: this.state.showNoTicket ? 'none' : 'block', height: "400px"
                                                }} >
                                                    <div className="card-body raise-form" style={{ backgroundColor: "#eff4f9" }}>
                                                        <div className="form-group col-6 pull-left p-0">

                                                            <h2 className={this.state.ticketTitle == '' ? '' : "signinTitle cursor-change"} title="Click here to close or reopen ticket"
                                                                style={{ textAlign: "left", margin: '10px 0px' }}>{this.state.ticketTitle === '' ? '' : this.state.ticketTitle}</h2>
                                                            <h6>{this.state.ticketType}</h6>
                                                            <h8>{this.state.ticketFileName}</h8><br /><br />
                                                            <h6 style={{ cursor: 'default' }}>Please checkout the client bot&nbsp;
                                                                <a style={{ cursor: 'pointer', color: '#0094c8' }} onClick={this.routeToClientBot}>here</a>
                                                            </h6>

                                                            <DialogComponent width='400px' animationSettings={this.settings} header='Ticket'
                                                                showCloseIcon={true} buttons={this.ticketStatusButton} ref={dialog => this.dialogInstance = dialog}
                                                                visible={this.state.showTicketStatusPopup} close={this.dialogClose}>
                                                                <img src="assets/images/warn.svg"
                                                                    style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;Do you want to close the ticket?
                                                                Note: Press 'Yes' to &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Close or press 'No' to decline</DialogComponent>

                                                            <DialogComponent width='400px' animationSettings={this.settings} header='Ticket' showCloseIcon={true} buttons={this.ticketStatusButton} ref={dialog => this.dialogInstance = dialog} visible={this.state.showTicketStatusOpenPopup} close={this.dialogClose}><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;Do you want to reopen the ticket?
                                                                Note: Press 'Yes' to &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; reopen or press 'No' to decline</DialogComponent>

                                                        </div>
                                                        <div className="form-group col-6 pull-left" Align="Right">
                                                            <h4 style={{ color: (this.state.ticketStatus === "OPEN") ? "green" : "red", margin: "10px 0px" }}>{this.state.ticketType === '' ? '' : this.state.ticketStatus + '|'}</h4>
                                                            <h8>{this.state.lastModifiedDate}</h8><br />
                                                            <h8 style={{ color: (this.state.ticketPriority === "CRITICAL") ? "red" : "orange" }}>{this.state.ticketPriority}</h8>
                                                        </div>
                                                    </div>
                                                    <br />
                                                    <div id="reactTable" className="table mangeClientTable text-center">


                                                        <ReactTable id='reactTable'
                                                            data={this.state.ticketInfo}
                                                            columns={[
                                                                {
                                                                    Header: <b>Comments</b>,
                                                                    accessor: 'comment',
                                                                    minWidth: 17,
                                                                    overflow: "visible",
                                                                    sortable: false,
                                                                    Cell: props => (<div class="direct-chat-msg " Align="left" >
                                                                        <div class="direct-chat-text chat_left" style={{ marginTop: "20px", backgroundColor: "#fbf7f7" }} var date={new Date(props.original.commentTime)}>
                                                                            <b>{props.original.comment}</b>
                                                                            <br />

                                                                            {props.original.commentType === '' ? "" : props.original.commentType + ' ' + '|' + ' ' + props.original.commentTime}
                                                                        </div>
                                                                    </div>)
                                                                }]}
                                                            showPagination={false}
                                                            style={{ height: "215px" }}
                                                            defaultPageSize={this.state.ticketInfo.length}
                                                            pageSize={this.state.ticketInfo.length}
                                                        />

                                                    </div>
                                                    <br />
                                                    <div className="row" Align='center'>
                                                        <button type="button" className='btn action-button'
                                                            title="Post" style={{ float: 'center', marginLeft: '34%', display: this.state.showPostCommentsTextArea ? 'none' : 'block' }}
                                                            onClick={this.showPostCommentsTextAreaFunc}
                                                        >
                                                            <img src="./assets/images/add_white_24dp.png" ></img>
                                                            <span style={{ fontWeight: 'bold' }}>Post your comments</span>
                                                        </button>
                                                    </div>
                                                    <div className="row">
                                                        <div className='col-sm-10' Align='center' style={{ display: this.state.showPostCommentsTextArea ? 'block' : 'none' }} >
                                                            <textarea className="form-control" rows={3}
                                                                placeholder="Post something here .." id="comment" onChange={this.handleChangeComments}
                                                                style={{
                                                                    resize: 'none', width: "105%", height: '50px',
                                                                    display: this.state.showPostCommentsTextArea ? 'block' : 'none'
                                                                }}></textarea>
                                                            &nbsp;
                                                        </div>
                                                        <div className='col-sm-2' Align='right' style={{ display: this.state.showPostCommentsTextArea ? 'block' : 'none' }}>
                                                            <button type='button'
                                                                className='btn action-button'
                                                                onClick={this.saveTicketCommentsApi}>Submit</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BotStoreTickets;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/botStore/BotStoreTickets.js